/* BG COM 04/10/2026 (vitesse) : sorti tel quel de snippets/bgcom-sticky-buy.liquid (bloc <script> en ligne), chargé en defer. */
(function(){
  function init(){
    var host = document.querySelector('product-sticky-form');
    if(!host || host.classList.contains('bgsb')) return;
    var card = host.firstElementChild, btn = host.querySelector('button[type="submit"]');
    if(!card || !btn) return;
    host.classList.add('bgsb');

    /* sentence-case label, "au panier" dropped on phones; the theme rewrites the label after an add
       or a variant change, so re-apply whenever it comes back as the plain add-to-cart text */
    var bt = btn.querySelector('.btn-text');
    function fixLabel(){
      if(!bt || bt.querySelector('.bgsb-long')) return;
      if(/^ajouter au panier$/i.test((bt.textContent || '').trim())) bt.innerHTML = '<span>Ajouter <span class="bgsb-long">au panier</span></span>';
    }
    fixLabel();
    if(bt) new MutationObserver(fixLabel).observe(bt, { childList:true, subtree:true, characterData:true });
    var media = host.querySelector('[data-sticky-product-media]');
    if(media) media.classList.remove('hidden');
    var cfg = document.createElement('span'); cfg.className = 'bgsb-cfg';
    cfg.innerHTML = 'Personnaliser<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="18 15 12 9 6 15"/></svg>';
    btn.appendChild(cfg);

    /* configurable products: a required field still empty -> go back to it */
    var form = document.getElementById(host.getAttribute('form'));
    function firstInvalid(){
      if(!form) return null;
      var els = form.elements;
      for(var i = 0; i < els.length; i++){ var el = els[i]; if(el.willValidate && el.type !== 'hidden' && !el.checkValidity()) return el; }
      return null;
    }
    function refreshCfg(){ host.classList.toggle('bgsb--cfg', !!firstInvalid()); }
    btn.addEventListener('click', function(e){
      var el = firstInvalid();
      if(!el) return;
      e.preventDefault(); e.stopImmediatePropagation();
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      /* focus + native message only once the scroll has landed, or the message's own scroll cuts it short */
      var done = false;
      function land(){
        if(done) return; done = true;
        var q = el.getBoundingClientRect();
        if(q.top < 140 || q.bottom > window.innerHeight - 120) el.scrollIntoView({ block:'center' });   // slow device: finish the job
        try{ el.focus({ preventScroll:true }); if(el.reportValidity) el.reportValidity(); }catch(_){}
      }
      var r = el.getBoundingClientRect();
      if(r.top > 140 && r.bottom < window.innerHeight - 120){ land(); return; }
      el.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
      if(reduce){ land(); return; }
      if('onscrollend' in window) window.addEventListener('scrollend', land, { once:true });
      setTimeout(land, 1100);
    }, true);
    document.addEventListener('input', refreshCfg, true);
    document.addEventListener('change', refreshCfg, true);
    refreshCfg();

    /* stay clear of the chat bubble */
    function chatRect(){
      /* bouton de chat Mister Paint (snippets/bgcom-chat-launcher) quand il remplace la bulle */
      var own = document.querySelector('.bgcom-chat.is-on [data-bgcom-chat-box]');
      if(own){   /* pastille + tête qui dépasse + liseré, hors animation (offset* ignore les transform) */
        var an = own.parentNode, fe = own.querySelector('.bgcom-chat__face');
        if(!an || !own.offsetWidth) return null;
        var x0 = an.offsetLeft, y0 = an.offsetTop, fx = fe ? fe.offsetLeft : 0, fy = fe ? fe.offsetTop : 0;
        var L = x0 + Math.min(0, fx) - 2, T = y0 + Math.min(0, fy) - 2;
        var R = x0 + Math.max(own.offsetWidth, fe ? fx + fe.offsetWidth : 0) + 2, B = y0 + Math.max(own.offsetHeight, fe ? fy + fe.offsetHeight : 0) + 2;
        return { left:L, top:T, right:R, bottom:B, width:R - L, height:B - T };
      }
      var c = document.querySelector('shopify-chat, inbox-online-store-chat');
      var root = c && c.shadowRoot; if(!root) return null;
      var a = root.querySelector('button.activator, .activator, button[aria-label]');
      if(!a) return null;
      var r = a.getBoundingClientRect();
      return (r.width && r.height && r.bottom > 0) ? r : null;
    }
    function place(){
      var vw = document.documentElement.clientWidth, vh = window.innerHeight, mob = vw < 768;
      var gap = mob ? 8 : 20, right = gap, bottom = gap, compact = false;
      var w = mob ? vw - 2 * gap : Math.min(680, vw - 2 * gap);
      var h = card.offsetHeight || (mob ? 68 : 106);
      var r = chatRect();
      if(r && r.top > vh * 0.5){
        /* default slot, including the lift the theme applies above the mobile dock */
        var ty = 0; try{ ty = new DOMMatrix(getComputedStyle(host).transform).m42 || 0; }catch(_){}
        var left = vw - gap - w, bot = vh - gap + ty, top = bot - h;
        var overlapX = r.left < vw - gap && r.right > left;
        var overlapY = r.top < bot + 8 && r.bottom > top - 8;
        /* phones: the dock shows and hides while scrolling, so any bubble in the same column counts */
        if(overlapX && (overlapY || mob)){
          var nr = Math.round(vw - r.left + (mob ? 8 : 12)), room = vw - gap - nr;
          if(!mob && vw - nr - w >= gap){ right = nr; }
          else if(mob && room >= 200){ right = nr; w = room; compact = room < 330; }   // price + button beside the bubble
          else { bottom = Math.round(vh - r.top + 12); }
        }
      }
      host.classList.toggle('bgsb--compact', compact);
      host.style.setProperty('--bgsb-right', right + 'px');
      host.style.setProperty('--bgsb-bottom', bottom + 'px');
      host.style.setProperty('--bgsb-w', w + 'px');
    }
    place();
    new MutationObserver(function(){ place(); refreshCfg(); }).observe(card, { attributes:true, attributeFilter:['style'] });
    var rz; window.addEventListener('resize', function(){ clearTimeout(rz); rz = setTimeout(place, 120); }, { passive:true });
    [1200, 3500, 8000].forEach(function(t){ setTimeout(place, t); });
    document.addEventListener('bgcom:chat-ready', place);   /* bouton de chat Mister Paint prêt (snippets/bgcom-chat-launcher) */

    /* step aside while the exploded view or the pack (its own add button) is on screen */
    function watchAway(){
      if(!('IntersectionObserver' in window)) return;
      var on = {};
      function set(k, v){ on[k] = v; host.classList.toggle('bgsb--away', !!(on.x3d || on.pack)); }
      var x = document.getElementById('nv3-root'), pk = document.querySelector('[data-bgb]');
      if(x) new IntersectionObserver(function(es){ es.forEach(function(en){ set('x3d', en.isIntersecting); }); },
        { rootMargin:'-30% 0px -30% 0px' }).observe(x);
      if(pk) new IntersectionObserver(function(es){ es.forEach(function(en){ set('pack', en.isIntersecting); }); },
        { rootMargin:'0px 0px -12% 0px' }).observe(pk);
    }
    watchAway();

    /* BGCOM 03/10 r3 (jury SEO) : la carte ne s'affiche qu'une fois le bloc d'achat dépassé par le haut. Le thème ne relit la
       position du formulaire que quand il entre dans l'écran ou en sort : après un saut (retour en haut, touche Début, ancre),
       son état « dépassé » restait vrai et la carte couvrait les cartes Conditionnement en haut de page (ordinateur et téléphone). */
    var scopeFrom = document.querySelector('.quick-order-list') || form, preRaf = 0;
    /* 04/10 r3 : bgsb--seen (une fois) dès que le bas du bloc d'achat est dans l'écran : la vignette de la carte (retenue par snippets/bgcom-cwv)
       se télécharge alors, avant que la carte n'apparaisse. */
    function pre(){ preRaf = 0; if(!scopeFrom){ host.classList.add('bgsb--seen'); return; } var vh = window.innerHeight || 0, b = scopeFrom.getBoundingClientRect().bottom; host.classList.toggle('bgsb--pre', b >= 0); if(b < vh) host.classList.add('bgsb--seen'); }
    function preQ(){ if(!preRaf) preRaf = requestAnimationFrame(pre); }
    pre();
    window.addEventListener('scroll', preQ, { passive:true });
    window.addEventListener('resize', preQ, { passive:true });
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
